import style from './profileCard.module.css';

import ProgressBar from '../progressBar/progressBar';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import CallOutlinedIcon from '@mui/icons-material/CallOutlined';

export default function ProfileCard(props) {
    return (
        <div className={style.profileComponent}>
            <div className="card shadow  p-3 p-lg-4">
                {/* Profile top row */}
                <div className="d-flex align-items-center mb-2">
                    {/* Profile Icon Placeholder */}
                    <div
                        className="d-flex align-items-center justify-content-center rounded-circle me-3"
                        style={{
                            width: '50px',
                            height: '50px',
                            backgroundColor: '#f0f0f0',
                            fontSize: '24px',
                            fontWeight: 'bold',
                            color: '#3978f7',
                        }}
                    >
                        {props.imgAlt}
                    </div>

                    {/* Name + Position */}
                    <div>
                        <div className={style.userName}>{props.firstName} {props.lastName}</div>
                        <div className={style.position}>{props.position}</div>
                    </div>
                </div>

                {/* Contact Info */}
                <div className="row text-muted mb-0 mt-lg-1 ">
                    <div className="col-12 col-md-12 col-lg-6 d-flex align-items-center mb-1 mb-md-0">
                        <MailOutlineIcon className={`${style.icon} me-1`} />
                        <span className={style.details}>{props.email}</span>
                    </div>
                    <div className="col-12 col-md-12 col-lg-6 d-flex align-items-center">
                        <CallOutlinedIcon className={`${style.icon} me-1`} />
                        <span className={style.details}>{props.phone}</span>
                    </div>
                </div>

                <hr />

                {/* Progress Section */}
                <div className="row">
                    <div className="col-12 col-md-6 mb-1">
                        <div className="d-flex justify-content-between mb-1">
                            <span className={`${style.title} mb-1`}>Work Done</span>
                            <span className={style.percentagetext} >85%</span>
                        </div>
                        <ProgressBar percent={70} height={12} color="#3978f7ff" />
                    </div>

                    <div className="col-12 col-md-6 mb-1">
                        <div className="d-flex justify-content-between mb-1">
                            <span className={`${style.title} mb-1`}>Overall Rating</span>
                            <span className={style.percentagetext}>7.5</span>
                        </div>
                        <ProgressBar percent={70} height={12} color="#FFA500" />
                    </div>
                </div>
            </div>
        </div>
    );
}
